import { makeStyles } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { AutocompleteInput, useDataProvider } from 'react-admin'
import { useFilterList } from 'components/List/FilterContext'
import _ from 'lodash'

const useStyles = makeStyles({
  suggestionsContainerOpen: {
    zIndex: 2000,
  },
})

interface ResponseItemProps {
  id: number
  slug?: string
  path?: string
  title?: string
  type?: string
  vimeo_id?: string
  value?: string
  text?: string
  name?: string
  email?: string
}

export const ResourcesTitle = (item: ResponseItemProps): string => {
  const path = item?.path ? `${item.path} | ` : ''
  const title = item?.title ? `${item.title} | ` : ''
  const type = item?.type ? `${item.type} | ` : ''
  const vimeo_id = item?.vimeo_id ? `${item.vimeo_id} | ` : ''
  const slug = item?.slug ? `${item.slug} | ` : ''
  const text = item?.text ? `${item.text} | ` : ''
  const value = item?.value ? `${item.value}` : ''
  const name = item?.name ? ` ${item.name} ` : ''
  const email = item?.email ? ` ${item.email} ` : ''

  return `${type}${text}${title}${path}${vimeo_id}${slug}${value}${name}${email}`
}

export const ResourceSelector = (props: any) => {
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const {
    collection = [],
    externalLoading = true,
    resource = '',
    sort = {},
    filter = {},
    perPage = 5000,
    page = 1,
    choicesFilter = {},
    searchField = null,
    selectedValue = null,
    optionValue = 'id',
    sendFilter
  } = props

  const { onCloseFilterModal, setFilters } = useFilterList()
  const [ownCollection, setOwnCollection] = useState(collection)
  const [loading, setLoading] = useState(false)
  const [textToFind, setTextToFind] = useState<string>('')

  const createFilter = () => {
    return {
      ...filter,
      ...(selectedValue ? { [optionValue]: selectedValue } : {}),
      ...(searchField && textToFind && textToFind !== selectedValue
        ? { [searchField]: textToFind }
        : {}),
    }
  }

  const filteredCollection = (collection: any = [], choicesFilter: any) => {
    if ((!textToFind || !textToFind.length) && selectedValue) {
      const filtered = collection?.filter(
        (value: any) => value[optionValue] === selectedValue,
      )

      if (filtered.length) {
        return filtered
      }
    }

    if (choicesFilter?.target && choicesFilter?.filter) {
      const { target, filter, operator = 'equal' } = choicesFilter
      let filtered = collection

      if (operator === 'equal') {
        filtered = collection?.filter((value: any) => value[target] === filter)
      }

      if (operator === 'odd') {
        filtered = collection?.filter((value: any) => value[target] !== filter)
      }

      return filtered
    }

    return collection
  }

  const getListOfResources = async (resource: Array<string>) => {
    let collection = []
    const promises: Array<Promise<any>> = []
    resource.forEach((req: string) => {
      const promise = new Promise((resolve, reject) => {
        try {
          return dataProvider
            .getList(req, {
              filter: createFilter(),
              sort: { ...sort },
              pagination: { perPage, page },
            })
            .then((resp) => resolve(resp))
        } catch (error) {
          reject()
        }
      })
      promises.push(promise)
    })

    collection = await Promise.all(promises).then((results) => {
      let result: any = []
      results.forEach((response) => {
        const data = response?.data || []
        if (data?.length) result = [...result, ...data]
      })
      return result
    })

    collection = filteredCollection(collection, choicesFilter)
    return collection
  }

  const getListOfResource = async (resource: string) => {
    let collection: Array<any> = []
    const response = await dataProvider.getList(resource, {
      filter: createFilter(),
      sort: { ...sort },
      pagination: { perPage, page },
    })

    collection = filteredCollection(response?.data, choicesFilter)
    return collection
  }

  const loadCollection = async (resource: string | Array<string>) => {
    let collection = []

    if (typeof resource !== 'string') {
      collection = await getListOfResources(resource)
    } else {
      collection = await getListOfResource(resource)
    }

    setLoading(false)
    setOwnCollection(collection)
  }

  // const handleOnInputValueChange = useCallback(
  //   (inputValue: string) => {
  //     let useFilter: Record<string, string> = {}
  //     console.log("teste")
  //     useFilter[sendFilter] = inputValue
  //     if(!_.isEmpty(useFilter[sendFilter])){
  //       setFilters(useFilter, useFilter)
  //     }
      
  //     setTextToFind(() => inputValue)
  //   },
  //   [setTextToFind],
  // )

  const handleOnInputValueChange = useCallback(
    (inputValue: string) => {
      setTextToFind(() => inputValue)
    },
    [setTextToFind],
  )


  const debouncing = (value: string): boolean => {
    if (!externalLoading) return true

    return Boolean(value?.length > 2)
  }

  useEffect(() => {
    if (textToFind?.length > 2) {
      setLoading(true)
      loadCollection(resource)
    }
  }, [textToFind])

  useEffect(() => {
    if (selectedValue) {
      loadCollection(resource)
    }
  }, [selectedValue])

  return (
    <AutocompleteInput
      optionText={ResourcesTitle}
      {...props}
      loading={loading}
      choices={ownCollection}
      onInputValueChange={handleOnInputValueChange}
      resettable
      shouldRenderSuggestions={(value: string) => debouncing(value)}
      classes={{
        suggestionsContainer: classes.suggestionsContainerOpen,
      }}
    />
  )
}
